export default __webpack_public_path__ + "static/media/AppleShortcuts.35915715.png";